export const SCALE_STOPS = ['#84de3a', '#d7f113', '#fdd50b', '#ffa400', '#f25a01'];
export const FALLBACK_FILL = '#e0e0e0';

export function normalizeName(s) {
  return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
}

export function indexByName(regions) {
  const idx = {};
  (regions || []).forEach((r) => { idx[normalizeName(r.name)] = r; });
  return idx;
}

export function styleForFeature(index) {
  return (feature) => {
    const props = (feature && feature.properties) || {};
    const region = index[normalizeName(props.nazwa || props.name)];
    return {
      fillColor: region ? region.color : FALLBACK_FILL,
      color: '#555',
      weight: 1,
      fillOpacity: 0.75,
    };
  };
}

export function tooltipLabel(region) {
  if (!region) return '';
  if (region.score == null) return `${region.name} — brak danych`;
  return `${region.name} — ${region.score}/100 (${region.rating})`;
}
